import { useCurrentUser } from '@/react/hooks/useUser';

import { FormControl } from '@@/form-components/FormControl';
import { Select } from '@@/form-components/ReactSelect';
import { Link } from '@@/Link';

import { useSharedGitCredentials } from '../queries/useSharedGitCredentials';

type Props = {
  value?: number;
  onChange: (credentialId?: number) => void;
  error?: string;
};

export function SharedGitCredentialSelect({ value, onChange, error }: Props) {
  const { isPureAdmin } = useCurrentUser();
  const credentialsQuery = useSharedGitCredentials();
  const credentials = credentialsQuery.data ?? [];
  const selectedCredential = credentials.find((c) => c.id === value);

  return (
    <FormControl
      label="Shared credential"
      inputId="shared-git-credential-selector"
      errors={error}
    >
      <div className="flex flex-col gap-1">
        <Select
          placeholder="Select a shared credential"
          value={selectedCredential ?? null}
          options={credentials}
          getOptionLabel={(c) => c.name || ''}
          getOptionValue={(c) => String(c.id)}
          onChange={(credential) => onChange(credential?.id)}
          isClearable
          isLoading={credentialsQuery.isLoading}
          noOptionsMessage={() => 'No shared credentials available'}
          inputId="shared-git-credential-selector"
          data-cy="shared-git-credential-selector"
        />
        {isPureAdmin && (
          <Link
            to="portainer.settings.sharedcredentials"
            target="_blank"
            className="text-xs"
            data-cy="manage-shared-git-credentials-link"
          >
            Manage shared credentials
          </Link>
        )}
      </div>
    </FormControl>
  );
}
